<template>
  <m-header :fixed="fixed" class="header" :style="[background ? `background-color: ${background}` : '#FFC400']"
    :class="{ 'm-header_rtl': language === 'ar' }">
    <m-row align="center" justify="between" ph30 pv19>
      <m-col span="12" class="header__left">
        <a href="/">
          <img v-if="headerLogo" class="header__left--logo" radius8 :src="require(`../../assets/img/${headerLogo}`)" />
          <img v-if="headerNameLogo" class="header__left--name" ml10
            :src="require(`../../assets/img/${headerNameLogo}`)" />
        </a>
      </m-col>
      <m-col span="12" offset="0" class="header__right">
        <a v-if="isShowBtn" @click="onBtnClick">
          <van-button class="header__right--button" fr type="primary" :color="btnBackground"
            :style="[btnTextColor ? `color: ${btnTextColor}` : 'color: #ffffff']">{{ buttonText }}
          </van-button>
        </a>
      </m-col>
    </m-row>
  </m-header>
</template>
<script lang="ts">
import { getRequestLanguage } from '@/api/utils'
import { OpenAppEnum } from './types'
import { PropType, Ref, computed } from 'vue'
import { Button } from 'vant'

interface IHeaderState {
  onBtnClick: () => void
  language: Ref<string>
}

export default {
  components: {
    [Button.name as string]: Button
  },
  props: {
    background: {
      type: String as PropType<string>
    },
    btnBackground: {
      type: String as PropType<string>
    },
    btnTextColor: {
      type: String as PropType<string>
    },
    isShowBtn: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    headerLogo: {
      type: String as PropType<string>,
      default: ''
    },
    headerNameLogo: {
      type: String as PropType<string>,
      default: ''
    },
    buttonText: {
      type: String as PropType<string>,
      default: '下载App'
    },
    handleOpenApp: {
      type: Function as PropType<(position: OpenAppEnum) => void>,
      required: true
    },
    fixed: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    width: {
      type: String as PropType<string>,
      default: ''
    },
    height: {
      type: String as PropType<string>,
      default: ''
    }
  },
  setup(props: Readonly<{
    handleOpenApp: (position: OpenAppEnum) => void
  }>): IHeaderState {
    const onBtnClick = () => {
      props.handleOpenApp(OpenAppEnum.DOWNLOAD)
    }
    const language = computed(() => {
      return getRequestLanguage()
    })
    return {
      onBtnClick,
      language
    }
  }
}
</script>

<style lang="scss" scoped>
.m-header_rtl {
  direction: rtl;

  .header__right {
    display: flex;
    justify-content: flex-end;
  }
}

@include b(header) {
  width: 100%;
  height: 100px;
  max-width: 100%;

  @include e(left) {
    @include m(logo) {
      box-sizing: border-box;
      width: 70px;
      height: 70px;
    }

    @include m(name) {
      display: inline-block;
      height: 38px;
      color: #ffffff;
      vertical-align: middle;
      font-weight: bold;
      width: auto;
    }
  }

  @include e(right) {
    @include m(button) {
      width: auto;
      min-width: 130px;
      height: 60px;
      font-weight: bold;
      font-size: 24px;
      border-radius: 30px;
      -webkit-user-select: none;
      text-align: center;
      padding: 8px 14px;
      margin: 0px 8px;
    }
  }
}
</style>
